import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvCdssPerfService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      _enableRefreshToken: false,
      isMagellan: '0',
      _env: 'cdss-perf',
      _apiUrl: 'https://perf3-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://perf3-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer:
        "https://cdssperfadb2c.b2clogin.com/637415b8-e1e8-4a31-84dd-1e083a31feac/v2.0/",
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint:
        'https://cdssperfadb2c.b2clogin.com/cdssperfadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl:
        'https://cdssperfadb2c.b2clogin.com/cdssperfadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '12a9df75-d5ea-4a34-86f7-a9437fec1e9d',
      _scope:
        'openid profile https://cdssperfadb2c.onmicrosoft.com/api/cdss.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl:
        'https://cdssperfadb2c.b2clogin.com/cdssperfadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://perf3-login.p-cis.com/',
      _signInURL:
        'https://cdssperfadb2c.b2clogin.com/cdssperfadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO:
        'https://cdssperfadb2c.b2clogin.com/cdssperfadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl:
        'https://cdssperfadb2c.b2clogin.com/cdssperfadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://cdssperfadb2c.b2clogin.com/cdssperfadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _oktaClientId: '0oag4pjnccJymdJVS1d7',
      _oktaIssuer: 'https://child-welfare-digital-services.oktapreview.com/oauth2/ausg4pw2f3vLM5mwV1d7',
      _oktaRedirectUri: 'https://perf3-login.p-cis.com/auth/okta/callback',
      _authEndpoint:
        'https://cdssperfadb2c.b2clogin.com/cdssperfadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://cdssperfadb2c.b2clogin.com/cdssperfadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9aaf',
      _intercomAppId: 'bqgvwybf'
   
      };
  }
}
